import { MontanaMediaRatios } from "@montana/shared/media";

export const epiMediaRatioToEnum = (mediaRatio?: string): MontanaMediaRatios | false => {
    switch (mediaRatio?.toLowerCase()) {
        case 'portrait':
            return MontanaMediaRatios.Portrait
        case 'landscape':
            return MontanaMediaRatios.Landscape
        case 'square':
            return MontanaMediaRatios.Square
        case 'video':
            return MontanaMediaRatios.Video
        default:
            return false; // Set to manual if no ratio is provided.
    }
}
